import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Badge,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

function ListadoAnticipos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_NOTAS_CARGO = process.env.REACT_APP_URL_NOTAS_CARGO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [anticipos, setAnticipos] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [idAnticipoEdit, setIdAnticipoEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [fechaEdit, setFechaEdit] = useState("");
  const [idClienteEdit, setIdClienteEdit] = useState("");
  const [importeEdit, setImporteEdit] = useState("");
  const [importeEditViejo, setImporteEditViejo] = useState("");
  const [formaPagoEdit, setFormaPagoEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [utilizadoEdit, setUtilizadoEdit] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [text, setText] = useState(false);
  const [idBancoEdit, setIdBancoEdit] = useState("");
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState();
  const [formaPago, setFormaPago] = useState();
  const [importe, setImporte] = useState();
  const [idBanco, setIdBanco] = useState("");
  const [vendedor, setVendedor] = useState("");
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [selectedSaldo, setSelectedSaldo] = useState("pendientes");

  const [modalAplicaDevolucion, setModalAplicaDevolucion] = useState(false);
  const toggleAplicaDevolucion = () =>
    setModalAplicaDevolucion(!modalAplicaDevolucion);
  const [cliente, setCliente] = useState("");
  const [inputFields, setInputFields] = useState([]);
  const [clienteName, setClienteName] = useState("");
  const [numero, setNumero] = useState("");
  // Fecha del anticipo que se esta aplicando: el abono se registra con esta
  // fecha, no con la de hoy.
  const [fechaAnticipo, setFechaAnticipo] = useState("");
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}GeneralActivos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useMemo(() => {
    axios
      .get(
        `${URL_ANTICIPOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allAnticipos = response.data;
        let arrayTabla = allAnticipos
          .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              fecha: a.fecha,
              cliente: a.clientes[0].nombre_comercial,
              idCliente: a.clientes[0]._id,
              vendedor: a.clientes[0].vendedor[0]._id,
              banco: a.bancos[0].banco + " " + a.bancos[0].cuenta,
              idBanco: a.bancos[0]._id,
              importe: a.importe,
              formaPago: a.formaPago,
              saldo: a.saldo,
              utilizado: a.utilizado,
              numero: a.idAnticipo,
              is_active: a.is_active,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        setAnticipos(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  let totalPDF = 0;
  let totalImporteTabla = 0;
  let totalUtilizadoTabla = 0;
  let totalSaldoTabla = 0;

  function PDFTabla() {
    totalPDF = 0;
    const data = anticipos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedCliente == 0 || selectedCliente == c.idCliente)
      ) {
        totalPDF = totalPDF + c.importe;
        return [
          c.fecha,
          c.cliente,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(c.importe),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    doc.text("Detalle de Anticipos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Cliente", "Importe"]],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#f28029"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#f28029"],
      },
      theme: "grid",
      startY: 45,
      foot: [
        [
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalPDF),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save("DetalleAnticipos.pdf");
  }

  function excel() {
    const dataExcel = anticipos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedCliente == 0 || selectedCliente == c.idCliente)
      ) {
        return {
          Fecha: c.fecha,
          Cliente: c.cliente,
          Importe: c.importe,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `DetalleAnticipos-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: `DetalleAnticipos`,
        sheetFilter: ["Fecha", "Cliente", "Importe"],
        sheetHeader: ["Fecha", "Cliente", "Importe"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    totalPDF = 0;
    const data = anticipos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedCliente == 0 || selectedCliente == c.idCliente)
      ) {
        totalPDF = totalPDF + c.importe;
        return [
          c.fecha,
          c.cliente,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(c.importe),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    doc.text("Detalle de Anticipos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Cliente", "Importe"]],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#f28029"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#f28029"],
      },
      theme: "grid",
      startY: 45,
      foot: [
        [
          "",
          "ToPDFtal",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalPDF),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Anticipos",
          email: mailTo,
          fileName: "ListaAnticipos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Anticipos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Importe", field: "importe", sortable: true },
    { name: "Utilizado", field: "utilizado", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Aplicar", field: "aplicar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.cliente.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }

    if (selectedSaldo == "pendientes") {
      computedComments = computedComments.filter((e) => e.saldo != 0);
    }
    if (selectedSaldo == "pagadas") {
      computedComments = computedComments.filter((e) => e.saldo == 0);
    }

    setTotalItems(computedComments.length);

    if (
      sorting.field &&
      sorting.field != "importe" &&
      sorting.field != "utilizado" &&
      sorting.field != "saldo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe" ||
        sorting.field == "utilizado" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe" ||
        sorting.field == "utilizado" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedCliente,
    selectedSaldo,
  ]);

  function aplicarAnticipo(
    idDev,
    saldo,
    numero,
    idCliente,
    cliente,
    idBanco,
    vendedor,
    fechaAnticipoAplicar
  ) {
    setInputFields([]);
    setIdEdit(idDev);
    setFechaAnticipo(fechaAnticipoAplicar);
    setTotalGeneralEdit(saldo);
    setCliente(idCliente);
    setClienteName(cliente);
    setNumero(numero);
    setTotal(0);
    setSelectedBanco(idBanco);
    setVendedor(vendedor);

    axios
      .all([
        axios.get(`${URL_SURTIDOS}Cliente/${idCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }),
        axios.get(`${URL_NOTAS_CARGO}Cliente/${idCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }),
      ])
      .then(
        axios.spread((responseSurtidos, responseNotasCargo) => {
          let allCargos = responseSurtidos.data;
          let arrayTabla = allCargos
            .map((a) => {
              return {
                id: a._id,
                fecha: a.fecha,
                total_general: a.total_general,
                saldo: a.saldo,
                nota: a.idSurtido,
                importe: 0,
                clientes: a.clientes[0]._id,
                observaciones: "NA",
                movimiento: "Venta",
              };
            })
            .filter(function (el) {
              return el != null;
            });

          let allNotasCargo = responseNotasCargo.data;
          let arrayTablaNC = allNotasCargo
            .map((a) => {
              return {
                id: a._id,
                fecha: a.fecha,
                total_general: a.importe,
                saldo: a.saldo,
                nota: a.idNotaCargo,
                importe: 0,
                clientes: a.clientes[0]._id,
                observaciones: "NA",
                movimiento: "Nota de Cargo",
              };
            })
            .filter(function (el) {
              return el != null;
            });

          let dataFinal = [
            ...Object.values(arrayTabla),
            ...Object.values(arrayTablaNC),
          ];
          setInputFields(dataFinal);
        })
      )
      .catch((err) => {
        console.log(err);
      });

    toggleAplicaDevolucion();
  }

  function savePago() {
    if (
      parseFloat(total).toFixed(2) <= parseFloat(total_general_edit).toFixed(2)
    ) {
      Swal.fire({
        title: "Estas seguro?",
        text: "Se registrará el abono",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Enviar!",
      }).then((result) => {
        if (result.isConfirmed) {
          toggleProgreso();
          let totalMails = inputFields.length + 1;
          inputFields.map((a) => {
            if (a.importe > 0) {
              let body = {
                // El abono lleva la fecha del anticipo, no la de hoy
                fecha: fechaAnticipo || endDate,
                importe: a.importe,
                clientes: cliente,
                colaboradores: vendedor,
                formaPago: `Anticipo ${numero} Aplicado`,
                concepto: `Anticipo ${numero} Aplicado`,
                bancos: selectedBanco,
                comisionPagada: "No",
                observaciones: a.observaciones,
                codigoAgrupado,
                anticipos: idEdit,
              };

              if (a.movimiento === "Nota de Cargo") {
                body.notasCargo = a.id;
              } else {
                body.surtidos = a.id;
              }

              axios
                .post(`${URL_ABONOS}AplicarAnticipo`, body, {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                })
                .then((data) => {
                  if (a.movimiento === "Nota de Cargo") {
                    axios.patch(
                      `${URL_NOTAS_CARGO}AplicarAbono/${a.id}`,
                      {
                        saldo: a.saldo - a.importe,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                  } else {
                    axios.patch(
                      `${URL_SURTIDOS}/${a.id}`,
                      {
                        saldo: a.saldo - a.importe,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                  }

                  totalMails = totalMails - 1;
                  if (totalMails == 0) {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                  });
                  console.log(error);
                });
            } else {
              totalMails = totalMails - 1;
            }
          });

          axios
            .patch(
              `${URL_ANTICIPOS}AplicarAbono/${idEdit}`,
              {
                saldo: total,
                utilizado: total,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            )
            .then(() => {
              totalMails = totalMails - 1;
              if (totalMails == 0) {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
              console.log(error);
            });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El Importe a aplicar no coincide con el total de la Devolucion",
      });
    }
  }

  const handleChangeInputImporte = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (event.target.value <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesAbonos();
  };

  function ActualizaTotalesAbonos() {
    let TEfe = inputFields.map((c) => parseFloat(c.importe));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);
    setTotal(TE);
  }

  const handleChangeInputObser = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function EditAnticipo(
    _id,
    numero,
    fecha,
    idClientes,
    importe,
    formaPago,
    cliente,
    utilizado,
    idBanco
  ) {
    setIdAnticipoEdit(_id);
    setNumeroEdit(numero);
    setFechaEdit(fecha);
    setIdClienteEdit(idClientes);
    setImporteEdit(importe);
    setImporteEditViejo(importe);
    setFormaPagoEdit(formaPago);
    setClienteEdit(cliente);
    setUtilizadoEdit(utilizado);
    setIdBancoEdit(idBanco);
    toggleEdit();
  }

  const EditAnticipoSave = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el Anticipo",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ANTICIPOS}/${idAnticipoEdit}`,
            {
              importe: parseFloat(importeEdit) - parseFloat(importeEditViejo),
              idCliente: idClienteEdit,
              bancos: idBancoEdit,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Anticipo",
                detalle: `${clienteEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  };

  function cancelarAnticipo(idAnticipo) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara el Anticipo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_ANTICIPOS}Cancel/${idAnticipo}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuAnticipos ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    {user.anticiposCreate ? (
                      <Button
                        size="sm"
                        href="/AnticiposCreate"
                        className="btn btn-success"
                        id="botonListado"
                      >
                        Crear Anticipo
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        disabled
                        className="btn btn-success"
                        id="botonListado"
                      >
                        Crear Anticipo
                      </Button>
                    )}
                    <Button
                      size="sm"
                      href="/MenuAdmin"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i class="fas fa-at"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>Enviar Lista de Anticipos</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => {
                        setMailTo(e.target.value);
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      Enviar
                    </Button>
                  </ModalFooter>
                </Modal>
                <br />
                <h3 align="center">Anticipos</h3>
                <Row>
                  <Col md={2}>
                    <Label>Fecha Inicio</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Fin</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Cliente</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Saldo</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedSaldo}
                      onChange={(e) => {
                        setSelectedSaldo(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="pendientes">Pendiente</option>
                      <option value="pagadas">Aplicado</option>
                    </Input>
                  </Col>
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl"
                >
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  <tbody>
                    {commentsData.map((c) => {
                      totalImporteTabla = totalImporteTabla + c.importe;
                      totalUtilizadoTabla = totalUtilizadoTabla + c.utilizado;
                      totalSaldoTabla = totalSaldoTabla + c.saldo;
                      if (c.is_active == "Si") {
                        return (
                          <tr>
                            <td>{c.fecha}</td>
                            <td>{c.numero}</td>
                            <td> {c.cliente} </td>
                            <td>
                              {" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(c.importe)}{" "}
                            </td>
                            <td>
                              {" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(c.utilizado)}{" "}
                            </td>
                            <td>
                              {" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(c.saldo)}{" "}
                            </td>
                            <td>
                              {c.utilizado == 0 ? (
                                <>
                                  <Button
                                    size="sm"
                                    className="btn"
                                    color="info"
                                    onClick={(e) =>
                                      EditAnticipo(
                                        c._id,
                                        c.numero,
                                        c.fecha,
                                        c.idCliente,
                                        c.importe,
                                        c.formaPago,
                                        c.cliente,
                                        c.utilizado,
                                        c.idBanco
                                      )
                                    }
                                  >
                                    <i class="fas fa-edit"></i>
                                  </Button>
                                  {/* <Button
                                    size="sm"
                                    className="btn"
                                    color="danger"
                                    onClick={(e) => cancelarAnticipo(c._id)}
                                  >
                                    <i class="fas fa-ban"></i>
                                  </Button> */}
                                </>
                              ) : undefined}
                              {c.saldo > 0 ? (
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    aplicarAnticipo(
                                      c._id,
                                      c.saldo,
                                      c.numero,
                                      c.idCliente,
                                      c.cliente,
                                      c.idBanco,
                                      c.vendedor,
                                      c.fecha
                                    )
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>
                              ) : undefined}
                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr style={{ backgroundColor: "#ed8c8c" }}>
                            <td>{c.fecha}</td>
                            <td>{c.numero}</td>
                            <td> {c.cliente} </td>
                            <td>
                              {" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(c.importe)}{" "}
                            </td>
                            <td>
                              {" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(c.utilizado)}{" "}
                            </td>
                            <td>
                              {" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(c.saldo)}{" "}
                            </td>
                            <td>CANCELADO</td>
                          </tr>
                        );
                      }
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(totalImporteTabla)}
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(totalUtilizadoTabla)}
                      </td>

                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(totalSaldoTabla)}
                      </td>

                      <td></td>
                    </tr>
                  </tbody>
                </Table>
                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal
            size="xl"
            isOpen={modalAplicaDevolucion}
            toggle={toggleAplicaDevolucion}
          >
            <ModalHeader toggle={toggleAplicaDevolucion}>
              <h4>Aplicar Anticipo #{numero}</h4>
              <h4>Cliente {clienteName}</h4>
              <h4 align="right">
                Saldo{"  "}
                <Badge
                  id="Total"
                  color="danger"
                  className="BadgeSize badge-pill"
                >
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(total_general_edit)}
                </Badge>
              </h4>
            </ModalHeader>
            <ModalBody>
              <Table striped borderless>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Movimiento</th>
                    <th>Nota</th>
                    <th>Total</th>
                    <th>Abonos</th>
                    <th>Saldo</th>
                    <th>Importe</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields.map((a) => (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.movimiento}</td>
                      <td>{a.nota}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_general)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_general - a.saldo)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.saldo)}
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="0"
                          step="any"
                          name="importe"
                          value={a.importe}
                          key={a.id}
                          onChange={(e) => {
                            handleChangeInputImporte(a.id, e);
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="text"
                          name="observaciones"
                          value={a.observaciones}
                          key={a.id}
                          onChange={(e) => {
                            handleChangeInputObser(a.id, e);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td className="negrita" align="center">
                      Total
                    </td>
                    <td className="negrita">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(total)}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
                <br />
              </Table>

              <br />
              {validaBoton ? (
                <Button className="btn btn-success" onClick={savePago}>
                  {" "}
                  Registrar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Anticipo {numeroEdit} {clienteEdit}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={EditAnticipoSave}>
            <Row>
              <Col md={6}>
                <Label>Importe</Label>
                <Input
                  className="col-sm-12"
                  type="number"
                  placeholder="Importe"
                  value={importeEdit}
                  required
                  onChange={(e) => {
                    setImporteEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <br />
            <Row>
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>

              <div>
                <SweetAlert
                  show={text}
                  title="Creado con Exito"
                  onConfirm={() => {
                    setText(false);
                  }}
                />
              </div>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoAnticipos;